import {process, State} from "@progress/kendo-data-query"
import {Fade} from "@progress/kendo-react-animation"
import {Button} from "@progress/kendo-react-buttons"
import {Grid, GridColumn, GridDataStateChangeEvent, GridNoRecords, GridToolbar} from "@progress/kendo-react-grid"
import {Notification, NotificationGroup} from "@progress/kendo-react-notification"
import {useEffect, useState} from "react"
import {
    fetchDealers,
    resetAddEditResponse,
    setDealerDefaultSet,
    setSelectedTestStation,
    toggleAddEditModal,
} from "../../../containers/TestStation/testStationSlice"
import {RootState} from "../../../rootReducer"
import {columnProps} from "../../../shared/ActiveGridFilter"
import {useAppDispatch, useAppSelector} from "../../../store"
import {hasPermission} from "../../Shared/permissionChecker"

const initialState: State = {sort: [{field: "testStationName", dir: "asc"}], skip: 0, take: 100}

const TestStationsGrid = () => {
    const dispatch = useAppDispatch()

    const addEditResponse = useAppSelector((state: RootState) => state.containers.testStations.addEditResponse)
    const testStationsById = useAppSelector((state: RootState) => state.containers.testStations.testStationsData)
    const assignedPermissions = useAppSelector((state: RootState) => state.application.permissions)
    const verifyPermission = (checkPermissions: string[]) => hasPermission(checkPermissions, assignedPermissions)

    useEffect(() => {
        setDataState(initialState)
    }, [testStationsById])

    const toggleTestStationModel = (e: any, props: any) => {
        e.preventDefault()
        dispatch(toggleAddEditModal(true))
        dispatch(setSelectedTestStation(props.dataItem))
        dispatch(fetchDealers(props.dataItem.dealerID ? props.dataItem.dealerID : 0))
        dispatch(setDealerDefaultSet(props.dataItem.dealerID === 0 || props.dataItem.dealerID === null))
    }

    const NameLinkCell = (props: any) => (
        <td className="k-grid-content-sticky" style={{left: "0px"}}>
            <a
                href=" "
                style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                }}
                onClick={event => toggleTestStationModel(event, props)}
            >
                {props.dataItem.testStationName}
            </a>
        </td>
    )

    const [dataState, setDataState] = useState(initialState)
    return (
        <>
            <Grid
                style={{height: "calc(100vh - 10.3rem"}}
                data={process(testStationsById, dataState)}
                {...dataState}
                pageable={true}
                sortable={true}
                onDataStateChange={(e: GridDataStateChangeEvent) => {
                    setDataState(e.dataState)
                }}
            >
                <GridNoRecords> There is no data available</GridNoRecords>
                {verifyPermission(["TestStations.Add"]) && (
                    <GridToolbar>
                        <Button
                            fillMode="flat"
                            themeColor={"primary"}
                            className="buttons-container-button"
                            iconClass="fa fa-plus"
                            onClick={() => {
                                dispatch(toggleAddEditModal(true))
                                dispatch(fetchDealers(0))
                                dispatch(setDealerDefaultSet(true))
                            }}
                        >
                            New Test station
                        </Button>
                    </GridToolbar>
                )}

                <GridColumn
                    {...columnProps("testStationName", dataState)}
                    field="testStationName"
                    title="Station Name"
                    cell={props => <NameLinkCell {...props} />}
                    width="350px"
                    locked
                />
                <GridColumn
                    {...columnProps("dealerName", dataState)}
                    field="dealerName"
                    title="Local ATF"
                    width="250px"
                />
                <GridColumn {...columnProps("address1", dataState)} field="address1" title="Address" width="250px" />
                <GridColumn {...columnProps("address2", dataState)} field="address2" title="Address2" width="239px" />
                <GridColumn {...columnProps("town", dataState)} field="town" title="Town" width="210px" />
                <GridColumn {...columnProps("postCode", dataState)} field="postCode" title="Post Code" width="130px" />
                <GridColumn {...columnProps("phone", dataState)} field="phone" title="Phone" width="160px" />
                <GridColumn {...columnProps("email", dataState)} field="email" title="E-Mail" width="250px" />
            </Grid>
            <NotificationGroup
                style={{
                    right: "0.75rem",
                    top: "9.25rem",
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade>
                    {addEditResponse.isAddEditSuccessful && (
                        <Notification
                            style={{
                                right: 0,
                                bottom: 0,
                                alignItems: "flex-start",
                                flexWrap: "wrap-reverse",
                            }}
                            type={{style: addEditResponse.error === "" ? "success" : "error", icon: true}}
                            closable={true}
                            onClose={() => dispatch(resetAddEditResponse())}
                        >
                            {addEditResponse.error === "" ? "Success" : addEditResponse.error}
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>
        </>
    )
}

export default TestStationsGrid
